import { useLocation } from "#src/components/Router.tsx";
import { isServer } from "#src/utils/isServer.ts";
import { TypedSearchParams } from "./typedSearchParams";

export function useSearchParams(keysToFilter = []) {
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  keysToFilter.forEach((key) => params.delete(key));

  return params;
}

export function useTypedSearchParams<T>(keysToFilter = []) {
  const location = useLocation();
  const params = new TypedSearchParams<T>(location.search);

  keysToFilter.forEach((key) => params.delete(key));

  return params;
}

export function filterParams({
  key,
  value,
}: {
  key: string;
  value: string | string[];
}) {
  const location = isServer ? { search: "" } : window.location;
  const params = new URLSearchParams(location.search);
  let values = params.getAll(key);

  if (Array.isArray(value)) {
    values = value;
  } else {
    if (values.includes(value)) {
      values = values.filter((v) => v !== value && v !== "all");
    } else {
      values.push(value);
    }
  }

  params.delete(key);

  if (value !== "all") {
    for (const v of values) {
      if (v === "all") {
        continue;
      }

      params.append(key, v);
    }
  }

  return params;
}
